import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import API_CONFIG from "../commonApi/ApiConfig";

const Index = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    isActive: false,
    goldFee: "",
  });

  useEffect(() => {
    fetchPreference();
  }, []);

  const fetchPreference = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_CONFIG.BASE_URL}/api/v2/ProfessionalPreference/get`
      );
      const result = await response.json();

      if (result.success) {
        setForm({
          isActive: Boolean(result?.data?.isActive),
          goldFee:
            result?.data?.goldFee === 0 || result?.data?.goldFee
              ? String(result?.data?.goldFee)
              : "",
        });
      }
    } catch (error) {
      console.error("Error fetching professional preference:", error);
      toast.error("Failed to fetch professional preference");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${API_CONFIG.BASE_URL}/api/v2/ProfessionalPreference/add-update`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            isActive: form.isActive,
            goldFee: Number(form.goldFee) || 0,
          }),
        }
      );

      const result = await response.json();

      if (result.success) {
        toast.success("Professional preference updated successfully");
        setForm({
          isActive: Boolean(result?.data?.isActive),
          goldFee: String(result?.data?.goldFee ?? 0),
        });
      } else {
        toast.error(result.message || "Failed to save professional preference");
      }
    } catch (error) {
      console.error("Error saving professional preference:", error);
      toast.error("Failed to save professional preference");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-5 mt-4">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="card shadow">
            <div className="card-header bg-gradient d-flex align-items-center justify-content-between">
              <h4 className="card-title mb-0">Professional Preference</h4>
            </div>
            <div className="card-body">
              {loading ? (
                <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Section Status</label>
                      <select
                        className="form-control"
                        value={form.isActive ? "active" : "inactive"}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            isActive: e.target.value === "active",
                          }))
                        }
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label">Gold Extra Fee</label>
                      <input
                        type="number"
                        min="0"
                        className="form-control"
                        value={form.goldFee}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            goldFee: e.target.value,
                          }))
                        }
                        placeholder="Enter gold extra fee"
                      />
                      <small className="text-muted">
                        Prime stays default. Gold adds this amount in checkout.
                      </small>
                    </div>
                  </div>

                  <div className="text-end">
                    <button
                      className="btn btn-primary px-4"
                      onClick={handleSave}
                      disabled={loading}
                    >
                      Save Changes
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
